import { Image } from '@ccg/core';
import React$1, { useRef, useState, useContext, useEffect } from 'react';
import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Grid$1 from '../Grid/Grid.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import { useTransition, animated } from 'react-spring';
import { NavigationContext } from '../../contexts/NavigationProvider/NavigationProvider.js';
import StyledMainStageAnimation from './MainStageAnimation.style.js';

const MainStageAnimation = ({
  children,
  headline,
  images,
  mainStage
}) => {
  const image = useRef(null);
  const [index, setIndex] = useState(0);
  const [showAnimation, setShowAnimation] = useState(false);
  const [showText, setShowText] = useState(false);
  const [playedAnimation, setPlayedAnimation] = useState(false);
  const {
    setHiddenNavigationElements
  } = useContext(NavigationContext);
  const progressTransition = useTransition(showText && !playedAnimation, null, {
    from: {
      width: '0vw'
    },
    enter: {
      width: '100vw'
    },
    leave: {
      opacity: 0
    },
    config: {
      duration: Math.floor(4000 / images.length) * images.length
    }
  });
  const transitions = useTransition(images[index], item => item.id, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    config: {
      duration: 0
    }
  });
  const textTransition = useTransition(showText, null, {
    from: {
      transform: 'translateX(calc(100vw + 0%))'
    },
    enter: {
      transform: 'translateX(calc(-100vw + -100%))'
    },
    leave: {
      opacity: 0
    },
    config: {
      duration: Math.floor(4000 / images.length) * images.length
    }
  });
  useEffect(() => {
    if (window.innerWidth > 768 && !sessionStorage.getItem('playedAnimation')) {
      setShowAnimation(true);
      setHiddenNavigationElements(true);
      const firstImage = image.current.querySelector('img');

      if (firstImage) {
        firstImage.onload = () => {
          const intervalID = setInterval(() => {
            setIndex(state => {
              if (state === images.length - 1) {
                sessionStorage.setItem('playedAnimation', true);
                setPlayedAnimation(true);
                setHiddenNavigationElements(false);
                window.clearInterval(intervalID);
                return state;
              }

              return state + 1;
            });
          }, Math.floor(4000 / images.length));
          setShowText(true);
        };
      } else {
        setPlayedAnimation(true);
      }
    } else {
      setPlayedAnimation(true);
    }
  }, []);
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(StyledMainStageAnimation, {
    playedAnimation: playedAnimation,
    showAnimation: showAnimation
  }, /*#__PURE__*/React$1.createElement(Grid$1, {
    className: "mainStageAnimation__wrapper"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "mainStageAnimation__image-wrapper"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "mainStageAnimation__image-ratio"
  }, transitions.map(({
    item,
    props,
    key
  }) => /*#__PURE__*/React$1.createElement(animated.div, {
    key: key,
    className: "mainStageAnimation__image",
    style: _objectSpread2({}, props),
    ref: image
  }, (item.url || item.src) && /*#__PURE__*/React$1.createElement(Image, {
    src: item.url || item.src,
    srcset: item.srcset,
    alt: item.alt,
    sizes: "(min-width: 768px) 50vw, 75vw",
    lazy: true
  }))))), textTransition.map(({
    item,
    key,
    props
  }) => item && /*#__PURE__*/React$1.createElement(animated.div, {
    className: "mainStageAnimation__headline",
    key: key,
    style: _objectSpread2({}, props)
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "hero",
    as: "h1"
  }, headline)))), progressTransition.map(({
    item,
    key,
    props
  }) => item && /*#__PURE__*/React$1.createElement(animated.div, {
    className: "mainStageAnimation__progress",
    key: key,
    style: _objectSpread2({}, props)
  })), mainStage), playedAnimation && children);
};

MainStageAnimation.propTypes = {
  children: PropTypes$1.node.isRequired,
  headline: PropTypes$1.string.isRequired,
  images: PropTypes$1.arrayOf(PropTypes$1.shape({
    src: PropTypes$1.string,
    url: PropTypes$1.string,
    srcset: PropTypes$1.shape(),
    alt: PropTypes$1.string,
    width: PropTypes$1.number,
    height: PropTypes$1.number
  })).isRequired,
  mainStage: PropTypes$1.element.isRequired
};

export default MainStageAnimation;
